import { useMemo } from 'react';
import { useSelector } from 'react-redux';

import { selectTeamChatMessages } from 'store/teamChat/selectors';

import { buildEntityReferenceIndex } from './utils';

// Powers the entity-reference badges (Financial Info rows, borrower cards) and the drawer's
// References rail (DEV-5448). Read-only — pair with useEnsureChannelMessagesLoaded at a container
// level to make sure `chatId`'s messages are actually in the store.
const useEntityReferenceIndex = chatId => {
  const messages = useSelector(selectTeamChatMessages(chatId));

  return useMemo(() => buildEntityReferenceIndex(messages), [messages]);
};

export default useEntityReferenceIndex;
